module.exports = __webpack_public_path__ + "static/media/destaque-cave.c3c7fa77.png";